
import { GlobalContext } from 'components/GlobalContext';
import { useContext, useEffect, useRef } from 'react';
import { Navbar } from 'react-bootstrap';
import { Route, Routes, useNavigate } from 'react-router-dom';
import ReportsLookup from './Lookup';
import OpportunitiesReport from './OpportunitiesReport';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import './styles/Reports.scss';
import HRAOverviewReport from './HRAOverviewReport';

const ReportsIndex = () => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;
    const navigate = useNavigate();

    useEffect(() => {
        globalContextRef.current.setSecondaryNav(<>
            <Navbar.Brand
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}><strong><FontAwesomeIcon icon={faChevronLeft as IconProp} />&nbsp;Reports Directory</strong></Navbar.Brand>
        </>);
    }, []);

    return (
        <>
            <div>
                <Routes>
                    <Route path={"/Opportunities"} element={<OpportunitiesReport />} />
                    <Route path={"/HRAOverviewReport"} element={<HRAOverviewReport />} />
                    <Route path={"/*"} element={<ReportsLookup />} />
                </Routes>
            </div>
        </>
    );
}

export default ReportsIndex;
